import { css } from 'react-emotion';

export namespace animations {
  export const dropdown = {
    entering: css({
      opacity: 1,
      transformOrigin: 'top',
      transform: 'translate(0%, 0%) translateZ(.01px) scaleY(0.1)',
      transition: 'opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }),
    entered: css({
      opacity: 1,
      transformOrigin: 'top',
      transition:
        'opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      transform: 'translate(0%, 0%) scale(1)'
    }),
    exiting: css({
      opacity: 1,
      transformOrigin: 'top',
      transform: 'translate(0%, 0%) translateZ(.01px) scaleY(0.1)',
      transition: 'opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    })
  };
}
